const CartActionDebug = window.CartActionDebug || null;

function _shopifyFormatMoney(cents, format) {
  const rounded = Math.round(cents);
  const amount = (rounded / 100).toFixed(2);
  const amountNoDecimals = String(Math.round(rounded / 100));
  const withComma = amount.replace(/\d(?=(\d{3})+\.)/g, '$&,');
  const noDecimalsWithComma = amountNoDecimals.replace(/\d(?=(\d{3})+$)/g, '$&,');
  return (format || '{{amount}}')
    .replace('{{amount_with_comma_separator}}', withComma)
    .replace('{{amount_no_decimals_with_comma_separator}}', noDecimalsWithComma)
    .replace('{{amount_no_decimals}}', amountNoDecimals)
    .replace('{{amount}}', amount);
}

function _predictGiftRemoval(line, newQuantity) {
  try {
    const cached = window.__elanora_cart_cache;
    if (!cached || !cached.data || !cached.data.items) return null;

    const configEl = document.getElementById('free-gift-config');
    if (!configEl || configEl.dataset.freeGiftEnabled !== 'true') return null;

    const threshold = parseInt(configEl.dataset.freeGiftThreshold || '0', 10);
    const giftVariantId = parseInt(configEl.dataset.freeGiftVariantId || '0', 10);
    if (!threshold || !giftVariantId) return null;

    const items = cached.data.items;
    const lineIndex = parseInt(line, 10) - 1;
    if (lineIndex < 0 || lineIndex >= items.length) return null;

    const changedItem = items[lineIndex];
    const unitPrice = changedItem.final_price || 0;
    const newLineTotal = unitPrice * parseInt(newQuantity, 10);
    const currentTotal = cached.data.total_price || 0;
    const predictedTotal = currentTotal - (changedItem.final_line_price || 0) + newLineTotal;

    if (currentTotal < threshold || predictedTotal >= threshold) return null;

    const giftItem = items.find((item) =>
      item.variant_id === giftVariantId &&
      item.properties &&
      (item.properties._free_gift === 'true' || item.properties._free_gift === true)
    );
    if (!giftItem) return null;

    const updates = items.map((item, idx) => {
      if (idx === lineIndex) return parseInt(newQuantity, 10);
      if (item.key === giftItem.key) return 0;
      return item.quantity;
    });

    return { updates };
  } catch (_) {
    return null;
  }
}

function parseCartMarkup(html) {
  return new DOMParser().parseFromString(html, 'text/html');
}

function getCartSectionInnerHTML(html, selector = '.shopify-section') {
  const parsed = parseCartMarkup(html);
  const target = parsed.querySelector(selector);
  return target ? target.innerHTML : '';
}

function primaryUpsellVariantChange() {
  const upsellContainers = document.querySelectorAll('.cart-upsell-container');

  upsellContainers.forEach((container) => {
    const variantSelects = container.querySelector('[id^="variant-selects-cart-upsell-"]');
    if (!variantSelects) return;

    const productForm = container.querySelector('form');
    if (!productForm) return;

    const productIdField = productForm.querySelector('input[name="id"]');
    if (!productIdField) return;

    const selects = variantSelects.querySelectorAll('select');
    const variantsScript = variantSelects.querySelector('script[type="application/json"]');
    if (!variantsScript) return;

    const variants = JSON.parse(variantsScript.textContent);
    const selectedOptions = [];

    selects.forEach((select) => {
      selectedOptions.push(select.value);
    });

    const selectedVariant = variants.find((variant) => {
      return variant.options.every((option, index) => option === selectedOptions[index]);
    });

    if (!selectedVariant) return;

    productIdField.value = selectedVariant.id;
    const upsellImage = container.querySelector('.cart-upsell__image__img');

    if (upsellImage && selectedVariant.featured_image && selectedVariant.featured_image.src) {
      upsellImage.src = selectedVariant.featured_image.src;
    }
  });
}

function secondaryUpsellVariantChange() {
  const secondaryUpsellContainer = document.querySelector('.cart-secondary-upsell');
  if (!secondaryUpsellContainer) return;

  const variantSelects = secondaryUpsellContainer.querySelector('#variant-selects-cart-upsell-2');
  if (!variantSelects) return;

  const productForm = secondaryUpsellContainer.querySelector('.form');
  if (!productForm) return;

  const productIdField = productForm.querySelector('input[name="id"]');
  if (!productIdField) return;

  const variantsScript = variantSelects.querySelector('script[type="application/json"]');
  if (!variantsScript) return;

  const selectedVariant = JSON.parse(variantsScript.textContent).find((variant) => {
    for (let index = 0; index < variant.options.length; index += 1) {
      const selectElement = document.querySelector(`#Option-cart-upsell-2-${index}`);
      if (!selectElement || selectElement.value !== variant.options[index]) {
        return false;
      }
    }

    return true;
  });

  if (!selectedVariant) return;

  productIdField.value = selectedVariant.id;
  variantSelects.setAttribute('data-product-id', selectedVariant.id);

  if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
    const upsellImage = secondaryUpsellContainer.querySelector('.cart-secondary-upsell__image__img');
    if (upsellImage) {
      upsellImage.src = selectedVariant.featured_image.src;
    }
  }
}

window.primaryUpsellVariantChange = primaryUpsellVariantChange;
window.secondaryUpsellVariantChange = secondaryUpsellVariantChange;

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.boundClose = this.close.bind(this);
    this.bindOverlayClose();
    this.setHeaderCartIconAccessibility();
    this.defaultLoadingDuration = 1000;
    this.loadingHideTimeout = null;
    this.loadingMinVisibleUntil = 0;
    this.loadingStateActive = false;
    this.loadingRequestCount = 0;
    this.loadingLayer = this.querySelector('[data-cart-drawer-loading]');
    this.firstOpenRefreshDone = false;
    this.pendingInitialRefresh = null;
    this._handleDrawerLoadingStart = (event) => {
      const minDuration = event && event.detail && typeof event.detail.minDuration === 'number'
        ? event.detail.minDuration
        : undefined;
      this.showLoadingOverlay(minDuration);
    };
    this._handleDrawerLoadingStop = () => {
      this.hideLoadingOverlay();
    };
    this.refreshLoadingLayer();
  }

  connectedCallback() {
    document.addEventListener('cart:drawer-loading-start', this._handleDrawerLoadingStart);
    document.addEventListener('cart:drawer-loading-stop', this._handleDrawerLoadingStop);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:drawer-loading-start', this._handleDrawerLoadingStart);
    document.removeEventListener('cart:drawer-loading-stop', this._handleDrawerLoadingStop);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy, options = {}) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    if (!options.skipRefresh && !this.firstOpenRefreshDone) {
      if (!this.pendingInitialRefresh) {
        this.pendingInitialRefresh = this.refreshCartDrawer()
          .catch((error) => {
            if (CartActionDebug && CartActionDebug.enabled()) {
              console.warn('[cart-debug] initial drawer refresh failed', error);
            }
          })
          .finally(() => {
            this.firstOpenRefreshDone = true;
            this.pendingInitialRefresh = null;
            this.open(null, { skipRefresh: true });
          });
      }
      return;
    }

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => { this.classList.add('animate', 'active'); });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    showCartUpsellContainer();

    document.body.classList.add('overflow-hidden');
  }

  bindOverlayClose() {
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.boundClose);
  }

  refreshCartDrawer() {
    const trace = CartActionDebug ? CartActionDebug.start('drawer-initial-refresh') : null;
    if (CartActionDebug) CartActionDebug.step(trace, 'fetch-start');

    return fetch(`${routes.cart_url}?section_id=cart-drawer&_=${Date.now()}`, {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then((response) => {
        if (CartActionDebug) {
          CartActionDebug.step(trace, 'fetch-response', {
            status: response.status
          });
        }
        return response.text();
      })
      .then((responseText) => {
        const parsed = parseCartMarkup(responseText);
        const sourceDrawer = parsed.querySelector('cart-drawer');
        const sourceCartDrawer = parsed.querySelector('#CartDrawer');
        const currentCartDrawer = this.querySelector('#CartDrawer');

        if (!sourceCartDrawer || !currentCartDrawer) return;

        if (sourceDrawer) {
          this.classList.toggle('is-empty', sourceDrawer.classList.contains('is-empty'));
        }

        currentCartDrawer.innerHTML = sourceCartDrawer.innerHTML;
        this.bindOverlayClose();
        this.refreshLoadingLayer();
        if (CartActionDebug) CartActionDebug.end(trace);
      })
      .catch((error) => {
        if (CartActionDebug) {
          CartActionDebug.end(trace, 'error', {
            message: error && error.message ? error.message : 'initial drawer refresh failed'
          });
        }
        throw error;
      });
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    this.refreshLoadingLayer();

    try {
      document.dispatchEvent(new CustomEvent('cart:drawer-rendered', {
        detail: { productId: this.productId }
      }));
    } catch (_error) {}

    setTimeout(() => {
      this.bindOverlayClose();
      this.firstOpenRefreshDone = true;
      this.open(null, { skipRefresh: true });
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return getCartSectionInnerHTML(html, selector);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return parseCartMarkup(html).querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  refreshLoadingLayer() {
    this.loadingLayer = this.querySelector('[data-cart-drawer-loading]');
    if (!this.loadingLayer) return;

    if (this.loadingStateActive) {
      this.loadingLayer.classList.add('is-visible');
      this.loadingLayer.setAttribute('aria-hidden', 'false');
    } else {
      this.loadingLayer.classList.remove('is-visible');
      this.loadingLayer.setAttribute('aria-hidden', 'true');
    }
  }

  showLoadingOverlay(minDuration) {
    if (this.loadingRequestCount < 0) this.loadingRequestCount = 0;
    this.loadingRequestCount += 1;
    const layer = this.getLoadingLayer();

    if (this.loadingHideTimeout) {
      clearTimeout(this.loadingHideTimeout);
      this.loadingHideTimeout = null;
    }

    const duration = typeof minDuration === 'number' ? Math.max(minDuration, 0) : this.defaultLoadingDuration;
    const visibleUntil = Date.now() + duration;
    this.loadingMinVisibleUntil = Math.max(this.loadingMinVisibleUntil, visibleUntil);
    this.loadingStateActive = true;

    if (layer) {
      layer.classList.add('is-visible');
      layer.setAttribute('aria-hidden', 'false');
    }
  }

  hideLoadingOverlay() {
    if (this.loadingRequestCount > 0) {
      this.loadingRequestCount -= 1;
    }
    if (this.loadingRequestCount > 0) {
      return;
    }

    const remaining = this.loadingMinVisibleUntil - Date.now();
    if (remaining > 0) {
      if (this.loadingHideTimeout) clearTimeout(this.loadingHideTimeout);
      this.loadingHideTimeout = setTimeout(() => this.forceHideLoadingOverlay(), remaining);
      return;
    }

    this.forceHideLoadingOverlay();
  }

  forceHideLoadingOverlay() {
    this.loadingHideTimeout = null;
    this.loadingMinVisibleUntil = 0;
    this.loadingStateActive = false;
    const layer = this.getLoadingLayer();
    if (!layer) return;

    layer.classList.remove('is-visible');
    layer.setAttribute('aria-hidden', 'true');
  }

  getLoadingLayer() {
    if (!this.loadingLayer || !this.loadingLayer.isConnected) {
      this.loadingLayer = this.querySelector('[data-cart-drawer-loading]');
    }
    return this.loadingLayer;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return getCartSectionInnerHTML(html, selector);
  }

  onCartUpdate() {
    const trace = CartActionDebug ? CartActionDebug.start('drawer-refresh', {
      source: 'pub-sub'
    }) : null;
    if (CartActionDebug) CartActionDebug.step(trace, 'fetch-start');

    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => {
        if (CartActionDebug) {
          CartActionDebug.step(trace, 'fetch-response', {
            status: response.status
          });
        }
        return response.text();
      })
      .then((responseText) => {
        if (CartActionDebug) {
          CartActionDebug.step(trace, 'response-text', {
            bytes: responseText.length
          });
        }
        const html = parseCartMarkup(responseText);
        const sourceQty = html.querySelector('cart-items');

        this.innerHTML = sourceQty ? sourceQty.innerHTML : '';
        if (CartActionDebug) {
          CartActionDebug.step(trace, 'innerHTML-swap');
          CartActionDebug.end(trace);
        }
      })
      .catch((error) => {
        if (CartActionDebug) {
          CartActionDebug.end(trace, 'error', {
            message: error && error.message ? error.message : 'drawer refresh failed'
          });
        }
        console.error(error);
      });
  }

  updateQuantity(line, quantity, name) {
    const requestState = this.registerPendingQuantityRequest(line, quantity);
    if (!requestState) {
      this.pendingCartTrace = null;
      return;
    }

    const trace = CartActionDebug
      ? (this.pendingCartTrace || CartActionDebug.start('drawer-quantity-change', {
        line,
        quantity,
        trigger: name || 'unknown'
      }))
      : null;
    let traceStatus = 'ok';
    let traceMeta = {};
    this.pendingCartTrace = null;
    if (CartActionDebug) CartActionDebug.step(trace, 'updateQuantity-enter');

    let _optimisticEl = null;
    let _originalPrice = null;
    const _qtyInput = document.getElementById(`Drawer-quantity-${line}`);
    if (_qtyInput) {
      const unitCents = parseInt(_qtyInput.dataset.unitPrice, 10);
      const fmt = _qtyInput.dataset.moneyFormat;
      if (!isNaN(unitCents) && fmt) {
        const row = _qtyInput.closest('tr') || _qtyInput.closest('.cart-item');
        _optimisticEl = row ? row.querySelector('.cart-drawer__final-item-price') : null;
        if (_optimisticEl) {
          _originalPrice = _optimisticEl.textContent;
          _optimisticEl.textContent = _shopifyFormatMoney(unitCents * parseInt(quantity, 10), fmt);
          _optimisticEl.setAttribute('data-optimistic', '1');
        }
      }
    }

    this.enableLoading(line);
    if (CartActionDebug) CartActionDebug.step(trace, 'loading-enabled');
    document.dispatchEvent(new CustomEvent('cart:drawer-loading-start', {
      detail: { minDuration: 0 }
    }));
    if (CartActionDebug) {
      CartActionDebug.step(trace, 'drawer-loading-start-dispatched', {
        minDurationMs: 0
      });
    }

    const sectionIds = this.getSectionsToRender().map((section) => section.section);
    const combined = _predictGiftRemoval(line, quantity);
    const cartUpdateUrl = routes.cart_change_url.replace(/\/change(\.js)?$/, '/update');
    const fetchUrl = combined ? cartUpdateUrl : `${routes.cart_change_url}`;
    const body = combined
      ? JSON.stringify({ updates: combined.updates, sections: sectionIds, sections_url: window.location.pathname })
      : JSON.stringify({ line, quantity, sections: sectionIds, sections_url: window.location.pathname });

    if (CartActionDebug) {
      CartActionDebug.step(trace, 'request-body-ready', {
        bytes: body.length,
        combined: !!combined
      });
    }

    if (CartActionDebug) CartActionDebug.step(trace, 'fetch-start');

    const fetchSignal = requestState.abortController ? requestState.abortController.signal : undefined;
    fetch(fetchUrl, { ...fetchConfig(), ...{ body }, ...(fetchSignal ? { signal: fetchSignal } : {}) })
      .then((response) => {
        if (CartActionDebug) {
          CartActionDebug.step(trace, 'fetch-response', {
            status: response.status
          });
        }
        return response.text();
      })
      .then((state) => {
        if (CartActionDebug) {
          CartActionDebug.step(trace, 'response-text', {
            bytes: state.length
          });
        }
        const parsedState = JSON.parse(state);
        if (!parsedState.errors) {
          try { window.__elanora_cart_cache = { data: parsedState, ts: Date.now() }; } catch (_) {}
        }
        if (CartActionDebug) {
          CartActionDebug.step(trace, 'json-parse', {
            itemCount: parsedState.item_count
          });
        }
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          traceStatus = 'error';
          traceMeta = {
            message: parsedState.errors
          };
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        if (CartActionDebug) CartActionDebug.step(trace, 'section-render-start');
        if (parsedState.sections) {
          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            if (CartActionDebug) CartActionDebug.step(trace, `section:${section.section}`);
          });

          showCartUpsellContainer();
        } else {
          this.onCartUpdate();
        }
        if (CartActionDebug) CartActionDebug.step(trace, 'section-render-end');

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value, 10)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        if (CartActionDebug) CartActionDebug.step(trace, 'focus-restored');

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
        if (CartActionDebug) CartActionDebug.step(trace, 'pubsub-published');
      }).catch((err) => {
        if (err && err.name === 'AbortError') return;
        if (_optimisticEl && _originalPrice !== null) {
          _optimisticEl.textContent = _originalPrice;
          _optimisticEl.removeAttribute('data-optimistic');
        }
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        traceStatus = 'error';
        traceMeta = {
          message: window.cartStrings.error
        };
      })
      .finally(() => {
        const wasAborted = fetchSignal && fetchSignal.aborted;
        document.dispatchEvent(new CustomEvent('cart:drawer-loading-stop'));
        if (!wasAborted) {
          this.disableLoading(line);
          this.clearPendingQuantityRequest(line, requestState.requestId);
          if (CartActionDebug) {
            CartActionDebug.step(trace, 'loading-disabled');
            CartActionDebug.end(trace, traceStatus, traceMeta);
          }
        }
      });
  }
}

function showCartUpsellContainer() {
  const cartUpsellContainerSelector = '.cart-upsell-container-2';

  const cartUpsellContainerElement = document.querySelector(cartUpsellContainerSelector);
  if (!cartUpsellContainerElement) return;

  const hasCartUpsellContainer = cartUpsellContainerElement.classList.contains('first-visit-controlled');

  if (hasCartUpsellContainer) {
    const cartUpsellContainerDisplayHours = cartUpsellContainerElement.dataset.displayHours || 24;

    showBlock({
      selector: '.cart-upsell-container-2',
      storageKey: 'cart_upsell_container_first_visit',
      expiredKey: 'cart_upsell_container_expired',
      displayHours: cartUpsellContainerDisplayHours,
      isAnimation: false,
    });
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
